import React, { useCallback, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Checkbox from '../../../../components/checkbox'
import ZipWidget from '../widgets/zip'
import KlarnaWidget from '../widgets/klarna'
import AfterpayMessage from '../../../../../../components/pay-messages/afterpay-message'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { SensorsTrack } from '../../../../../../utils/sensor'
import { useEffect } from 'react'
import PaypalMessage from '../../components/paypal-message'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { BigButton } from '../../../../../../components/button'
import {
    billingPlaceOrder,
    billingCheckout,
} from '../../../../../../../api'
import Ask from '../../../../components/ask'


const Widget = props => {
    useStyles(classes)
    const { payMethod, orderTotal, klarnas } = props
    let widget

    if (payMethod.id === '100') {
        widget = orderTotal?.currency === 'USD' && <ZipWidget className={classes.Widget} orderTotal={orderTotal} />
    } else if (payMethod.type === '27') {
        widget = <KlarnaWidget className={classes.Widget} payMethod={payMethod} klarnas={klarnas} />
    } else if (payMethod.id === '85') {
        widget = orderTotal?.currency === 'GBP' && <div className={classes.Widget}>
            <AfterpayMessage money={orderTotal} />
        </div>
    }else if (payMethod.id === '107') {
        widget = orderTotal?.currency === 'AUD' && <div className={classes.Widget}>
            <AfterpayMessage money={orderTotal} locale={"en_AU"} />
        </div>
    }

    return widget || <></>
}


const PaymentMethod = props => {
    useStyles(classes)
    const { payMethod, selectedPayMethod, selectPayMethodHandle, orderTotal, selectedCard, onError, inputOrder, shoudBilling, check } = props
    const { recommend, recommendTitle } = payMethod
    const global = useSelector(state => state.global)
    const history = useHistory()
    const hasPaypalMessage = global.config?.paypal?.showMessage
    const [paying, setPaying] = useState(false)

    const clickHandle = e => {
        SensorsTrack('PlaceOrderAction', {action: 'ClickPayMethod'})
        selectPayMethodHandle(payMethod.id)
    }

    const isCreditMethod =  payMethod.id === '88' || payMethod.id === '91' || payMethod.id === '101' || payMethod.id === '109'
    const isSelected = selectedPayMethod === payMethod.id

    // const {
    //     isSelected,
    //     quickpayRecord,
    //     style
    // } = card

    const changeCardHandle = useCallback(async e => {
        e.preventDefault()
        e.stopPropagation()

        if(check){
            if(!check()){
                return false
            }
        }


        setPaying(true)


        if(inputOrder){
            history.push(`/cart/credit-card/${inputOrder.id}?payMethod=${payMethod.id}`)
        }else{

            if(shoudBilling){
                await billingCheckout()
            }

            const response = await billingPlaceOrder()
            if (response?.code === 200 && response?.result) {
                history.push(`/cart/credit-card/${response?.result?.id}?payMethod=${payMethod.id}`)
            }else{
                onError({
                    message: response?.result || 'Network Error',
                    code: response?.code,
                    type: (response?.code === 407 || response?.code === 402) ? 'force_refresh' : null
                })
            }
        }

        
        setPaying(false)
    }, [])

    const handlePrevent = (e) =>{
        e.preventDefault()
        e.stopPropagation()
    }

    return <div className={classes.PaymentMethod} onClick={clickHandle}>
        <div className={classes.Body}>
            <div className={classes.CheckBox}>
                <Checkbox selected={isSelected} />
            </div>
            <div className={classes.Icon}>
                <img src={payMethod.icon} />
            </div>
            <div className={classes.Content}>
                {
                    isCreditMethod && selectedCard ? <div className={classes.CardContainer}>
                        <span className={classes.CardNumber}>{selectedCard.quickpayRecord?.cardNumber}</span>
                        <BigButton loading={paying} onClick={changeCardHandle} className={classes.ChangeButton}><FormattedMessage id="change" defaultMessage="Change"/></BigButton>
                    </div> : <>
                        <div className={classes.Name}>
                            <span className={classes.MarginR10}>{payMethod.name}</span>

                            {
                                payMethod?.message && !(selectedPayMethod === payMethod.id) && <Ask content={payMethod.message} />
                            }
                        </div>
                        {
                            payMethod.promotionMsg && <div className={classes.PromotionMsg}>{payMethod.promotionMsg}</div>
                        }
                    </>
                }
            </div>
        </div>
        
        {
            payMethod.imageURL && <div className={classes.PayImage}>
                <img src={payMethod.imageURL} alt="PayImage" />
            </div>
        }

        {
            '1' === payMethod.id && orderTotal?.currency === 'USD' && global.country === 'US' && hasPaypalMessage && <div className={classes.VisablePlugin}>
                <PaypalMessage orderTotal={orderTotal}/>
            </div>
        }

        {
            selectedPayMethod === payMethod.id && <Widget {...props} />
        }

        {
            selectedPayMethod === payMethod.id && payMethod.message && <div className={classes.Description} onClick={handlePrevent}>{payMethod.message}</div>
        }

        {
            recommend && <span className={classes.Recommed}>{recommendTitle}</span>
        }
    </div>
}

export default props => {
    useStyles(classes)
    const { payMethodList, className, ignoreViewMore,expanded, ...oProps } = props
    const { selectedPayMethod }=props
    const [len, setLen] = useState(4)

    const [shouldButton, setShouldButton] =  useState(!ignoreViewMore && payMethodList?.length > 4 && payMethodList?.findIndex?.(p => p.id === props.selectedPayMethod) < 4)

    const slicedList = shouldButton ? payMethodList?.slice(0, len): payMethodList

    useEffect(() => {
        setShouldButton(!ignoreViewMore && payMethodList?.length > 4 && payMethodList?.findIndex?.(p => p.id === props.selectedPayMethod) < 4)
    }, [payMethodList?.length])

    function foldDiv(){
        const filteredMethods = slicedList?.filter(payMethod => payMethod.id === selectedPayMethod);
        if (!filteredMethods || filteredMethods.length === 0) {
            return null;
        }
        return <div className={`${classes.PaymentMethods} ${className}`}>
            {
                filteredMethods?.map(payMethod => <PaymentMethod {...oProps} payMethod={payMethod} key={payMethod.id} />)
            }
        </div>
    }
    function expandedDiv(){
        return <div className={`${classes.PaymentMethods} ${className}`}>
            {
                slicedList?.map(payMethod => <PaymentMethod {...oProps} payMethod={payMethod} key={payMethod.id} />)
            }
            {
                (shouldButton && len !== payMethodList?.length) && <div className={classes.ViewMore} onClick={e => setLen(payMethodList?.length)}>
                    <FormattedMessage id="view_more" defaultMessage="View More" />
                    <Iconfont className={classes.Icon}>&#xe692;</Iconfont>
                </div>
            }
        </div>
    }
    return expanded?expandedDiv():foldDiv()
}